var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SolanLookbackPure',{attrs:{"message-view":_vm.messageView,"lookback-ref":function () { return _vm.lookback; },"reload-data":_vm.reloadData,"save-all":_vm.saveAll}})}
var staticRenderFns = []

export { render, staticRenderFns }